import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getLocaleSelector, getMpvid } from '~/app/store/config'
import { getForwardedPath, getUrlId } from '~/app/store/debug/reducer'
import { getDebugModeEnabled } from '~/app/store/debug'

export const useInitDebug = () => {
  const debugEnabled = useSelector(getDebugModeEnabled)

  const forwardedPath = useSelector(getForwardedPath)
  const locale = useSelector(getLocaleSelector)
  const mpvId = useSelector(getMpvid)
  const urlId = useSelector(getUrlId)

  useEffect(() => {
    console.log('=== Gallery Fragment ===')

    if (debugEnabled) {
      console.log(`Path: ${forwardedPath}; Locale: ${locale}; MPV: ${mpvId}; URL ID: ${urlId}`)
      console.log(`Local URL: http://localhost:12345/?forwardedPath=${forwardedPath}&locale=${locale}&productId=${mpvId}&urlId=${urlId}`)
    }
  }, [])
}
